<template>
	<div
		class="ms-input flex ms-editor"
		:class="{ isValid: errorProvider.isValid, 'input-disabled': disabled }"
	>
		<textarea
			class="ms-input-item pb-2 pt-2"
			:placeholder="placeholder"
			v-model="internalText"
			:disabled="disabled"
			ref="input"
			v-on="listeners"
		/>
		<div
			class="icon-input"
			v-tooltip="{
				content: errorProvider.message,
				show: focused,
				classes: 'error',
			}"
			v-if="errorProvider.isValid"
		>
			<div class="mi mi-20 mi-icon-error"></div>
		</div>
		<div :class="['icon-input', 'mi', 'mi-18', icon]" v-if="icon"></div>
	</div>
</template>
<script>
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
export default {
	extends: msBaseComponent,
	name: 'MsTextarea',
	props: {
		/**
		 * V-model bắn ra ngoài binding 2 chiều
		 */
		value: {
			default: null,
		},
		/**
		 * Hiện thị chũ mờ ở dưới ô input
		 * Created by LTDAT(22.06.2020)
		 */
		placeholder: {
			default: null,
			type: [Number, String],
		},
		disabled: {
			default: false,
			type: Boolean,
		},
		//class chứa icon
		icon: {
			default: null,
			type: String,
		},
	},
	data() {
		return {
			internalText: this.value,
			focused: false,
		};
	},
	computed: {
		listeners() {
			return {
				blur: (e) => {
					this.onBlur(e);
				},
				focus: (e) => {
					this.onFocus(e);
				},
				change: (e) => {
					this.validate(this.internalText);
					this.$emit('change', this.internalText, e);
				},
			};
		},
	},
	methods: {
		//Sự kiện focus vào ô input
		onFocus(e) {
			const me = this;
			me.focused = true;
		},
		//Sự kiên blur ra ngoài ô input
		onBlur(e) {
			const me = this;
			me.focused = false;
		},
		//Reset lại giá trị về ban đầu
		reset() {
			const me = this;
			me.internalText = null;
		},
		//Set giá trị cho ô input
		setValue(value) {
			const me = this;
			me.internalText = value;
		},
	},
	watch: {
		internalText: {
			handler(newVal, oldVal) {
				const me = this;
				me.validate(newVal);
				me.$emit('input', newVal);
			},
		},
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.setValue(newVal);
			},
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msInput.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msInput.scss';
}
</style>

